import {request} from '@umijs/max';
import BASEURLCONFIG from '../../../../config/BASEURLCONFIG';

export async function findOne(params) {
  return request('/api/wfApply/findOne', {
    params,
  });
}

export async function find(params) {
  return request('/api/wfApply/find', {
    params,
  });
}

export async function findWfApplyExtra(params) {
  return request('/api/wfApplyExtra/find', {
    params,
  });
}

export async function remove(params) {
  return request('/api/wfApply/delete', {
    method: 'POST',
    data: { ...params, method: 'delete' },
  });
}
export async function saveOrUpdate(params) {
  return request('/api/wfApply/saveOrUpdate', {
    method: 'POST',
    data: { ...params, method: 'post' },
  });
}

export async function findWfProcess(params) {
  return request('/api/wfProcess/find', {
    params,
  });
}

export async function toAudit(params) {
  return request('/api/v2/component/toAudit', {
    params,
  });
}
export async function hasAuditing(params) {
  return request('/api/v2/component/hasAuditing', {
    params,
  });
}
export async function hasAgree(params) {
  return request('/api/v2/component/hasAgree', {
    params,
  });
}
export async function hasReject(params) {
  return request('/api/v2/component/hasReject', {
    params,
  });
}
export async function hasAudit(params) {
  return request('/api/v2/component/hasAudit', {
    params,
  });
}
export async function myAll(params) {
  return request('/api/v2/component/myAll', {
    params,
  });
}
export async function acceptProcess(params) {
  return request('/api/v2/component/acceptProcess', {
    method: 'POST',
    data: { ...params, method: 'post' },
  });
}
export async function findStepLogByApplyId(params) {
  return request('/api/v2/component/findStepLogByApplyId', {
    params,
  });
}
export async function getFlowChart(params) {
  return request('/api/v2/component/getFlowChart', {
    params,
  });
}

export async function auditFlowChart(params) {
  let auditUrl = params.auditUrl;
  if (!auditUrl) {
    auditUrl = BASEURLCONFIG.IPR_DATA_SERVICE_URL;
  }
  return request(auditUrl + '/api/v2/component/auditFlowChart', {
    method: 'POST',
    data: { ...params, method: 'post' },
  });
}

export async function selectTranserUser(param) {
  console.log(param, 'param');
  return request('/api/v2/component/findUserToTransfer', {
    params: param,
  });
}

export async function saveTranserUser(param) {
  return request('/api/v2/component/transfer', {
    method: 'post',
    data: param,
  });
}

export async function myApplyForDeal(params) {
  return request('/api/v2/component/myApplyForDeal', {
    params,
  });
}
